import React from 'react'
import { useTrans, useUtente } from 'hooks'
import { WContainer, HeaderBox, LoaderOverlay } from '@components/atoms'
import { FormContattaci, FormLogin, Page } from 'components/organisms'
import styles from './ContattaciTemplate.module.sass'
import { PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
}

const ContattaciTemplate = ({ pagina }: Props) => {
  const { loading } = useUtente()

  return (
    <Page pagina={pagina} item={pagina} contentClassName={styles.template}>
      <WContainer variant="sm">
        <HeaderBox
          title={pagina.titolo}
          description={pagina.descrizione}
          classNameHeader={styles.header}
          classNameTitle={styles.title}
          classNameDescription={styles.description}
        />
        {loading ? <LoaderOverlay /> : <FormContattaci />}
      </WContainer>
    </Page>
  )
}

export default ContattaciTemplate
